<!-- Loader -->
<ng-template #loadingTpl>
  <div class="flex h-[360px] w-full flex-col items-center justify-center gap-4 text-gray-400">
    <div class="h-9 w-9 animate-spin rounded-full border-4 border-gray-300 border-t-gray-800"></div>
    <span class="text-sm font-medium">
      Post Format Usage
    </span>
  </div>
</ng-template>

<!-- Header -->
<div class="grid grid-cols-12 items-center gap-4 mb-6">

  <!-- Title -->
  <div class="col-span-12 sm:col-span-6">
    <h2 class="text-xl font-semibold tracking-tight text-gray-900">
      Post Format Usage
    </h2>
  </div>

  <!-- Legend -->
  <div class="col-span-12 sm:col-span-6 flex flex-wrap justify-start sm:justify-end gap-4">

    <div class="flex items-center gap-2 text-sm text-gray-700">
      <span class="h-3 w-3 rounded-sm bg-blue-600"></span>
      Engagement
    </div>

    <div class="flex items-center gap-2 text-sm text-gray-700">
      <span class="h-3 w-3 rounded-sm bg-emerald-500"></span>
      Clicks
    </div>

  </div>
</div>

<!-- TikTok Message -->
<ng-container *ngIf="isTikTok(); else notTiktokFormat">
  <div class="flex h-[360px] w-full flex-col items-center justify-center gap-4 rounded-2xl border border-dashed border-gray-200 bg-gray-50/70 p-6 text-center">
    <div>
      <p class="mb-1 text-sm font-semibold text-gray-500">
        TikTok analytics are not available yet.
      </p>
      <p class="text-xs text-gray-400">
        We're working on bringing you TikTok insights soon.
      </p>
    </div>
  </div>
</ng-container>

<!-- Non-TikTok Content -->
<ng-template #notTiktokFormat>
  <div *ngIf="isLoaded; else loadingTpl">

  <!-- Chart -->
  <div class="mb-6 rounded-3xl border border-gray-300 bg-white p-4">
    <apx-chart
      #chartRef
      [series]="chartOptions.series"
      [chart]="chartOptions.chart"
      [xaxis]="chartOptions.xaxis"
      [yaxis]="chartOptions.yaxis"
      [plotOptions]="chartOptions.plotOptions"
      [dataLabels]="chartOptions.dataLabels"
      [colors]="chartOptions.colors"
      [legend]="chartOptions.legend"
      class="block w-full"
    >
    </apx-chart>
  </div>

  <!-- Table -->
  <div class="overflow-x-auto rounded-3xl border border-gray-300 bg-white">

    <table class="min-w-full text-sm">

      <!-- Header -->
      <thead class="bg-gray-50">
        <tr class="text-left text-xs font-semibold uppercase tracking-wide text-gray-500">
          <th class="px-4 py-3"></th>
          <th class="px-4 py-3 text-center">Engagement</th>
          <th *ngIf="showSaves" class="px-4 py-3 text-center">Saves</th>
          <th class="px-4 py-3 text-center">Clicks</th>
        </tr>
      </thead>

      <!-- Body -->
      <tbody class="divide-y divide-gray-100">
        <tr
          *ngFor="let f of formats"
          class="transition hover:bg-gray-50"
        >
          <td class="px-4 py-3 font-semibold text-gray-900">
            {{ f.name }}
          </td>

          <td class="px-4 py-3 text-center text-gray-700">
            {{ f.engagement | number:'1.2-2' }}% ({{ f.engagementValue | number }})
          </td>

          <td *ngIf="showSaves" class="px-4 py-3 text-center text-gray-700">
            {{ f.saves | number:'1.2-2' }}% ({{ f.savesValue | number }})
          </td>

          <td class="px-4 py-3 text-center text-gray-700">
            {{ f.clicks | number:'1.2-2' }}% ({{ f.clicksValue | number }})
          </td>
        </tr>
      </tbody>

    </table>

  </div>

  <!-- Separator -->
  <div class="border-t border-gray-200 my-6"></div>

  <!-- Credit Balance Section -->
  <div class="mb-4">

    <!-- Credit Balance Table -->
    <div class="overflow-x-auto rounded-3xl border border-gray-300 bg-white">

      <!-- Loading State -->
      <div
        *ngIf="isCreditLoading"
        class="flex min-h-[120px] items-center justify-center"
      >
        <div
          class="h-5 w-5 animate-spin rounded-full border-2 border-gray-300 border-t-gray-800"
        ></div>
      </div>

      <!-- Error State -->
      <div
        *ngIf="!isCreditLoading && creditError"
        class="flex min-h-[120px] items-center justify-center px-4 py-6 text-center text-sm text-gray-500"
      >
        Credit balance is currently unavailable.
      </div>

      <!-- Success State -->
      <table
        *ngIf="!isCreditLoading && !creditError && creditSummary"
        class="min-w-full text-sm"
      >
        <thead class="bg-gray-50">
          <tr class="text-left text-xs font-semibold uppercase tracking-wide text-gray-500">
            <th class="px-4 py-3">
              Credit Information
            </th>

            <th class="px-4 py-3 text-center">
              Value
            </th>
          </tr>
        </thead>

        <tbody class="divide-y divide-gray-100">

          <!-- Available Credits -->
          <tr class="transition hover:bg-gray-50">
            <td class="px-4 py-3 font-semibold text-gray-900">
              Available Credits
            </td>

            <td class="px-4 py-3 text-center font-medium text-gray-700">
              {{
                creditSummary.active_credits !== null
                  ? (creditSummary.active_credits | number)
                  : 0
              }}
            </td>
          </tr>

          <!-- Current Plan -->
          <tr class="transition hover:bg-gray-50">
            <td class="px-4 py-3 font-semibold text-gray-900">
              Current Plan
            </td>

            <td class="px-4 py-3 text-center font-medium text-gray-700">
              {{
                creditSummary.has_active_plan && creditSummary.plan_title
                  ? creditSummary.plan_title
                  : 'No active plan'
              }}
            </td>
          </tr>

        </tbody>
      </table>

    </div>
  </div>

</div>
</ng-template>